import React from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { Box } from '@mui/material';
import Navigation from '../../components/navigation';
import Footer from '../../components/footer';
import NewsletterSignup from '../../components/newsletter-signup';
import MasqueradeBanner from '../../components/masquerade-banner';

type Props = {
  hideNav?: boolean;
  hidefooter?: boolean;
};

const LayoutWrapper = ({
  hideNav = false,
  hidefooter = false,
}: Props) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    }}
  >
    <ScrollRestoration />
    <MasqueradeBanner />
    {hideNav ? null : <Navigation />}
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <Outlet />
    </Box>
    {hidefooter ? null : <NewsletterSignup />}
    {hidefooter ? null : <Footer />}
  </Box>
);

export default LayoutWrapper;
